import type { ChecklistSummary } from '@/features/menu/utils/menu-checklist';
import { useT } from '@/i18n';

export function MenuChecklistChip({
  summary,
  onOpen,
}: {
  summary: ChecklistSummary;
  onOpen: () => void;
}) {
  const c = useT().menuChecklist;
  if (summary.total === 0) return null;
  const parts = [
    c.toCheck(summary.total),
    summary.unpriced > 0 && c.noPriceCount(summary.unpriced),
    summary.unknownAllergens > 0 && c.unknownAllergensCount(summary.unknownAllergens),
  ].filter(Boolean);
  return (
    <div className="menu-checklist">
      <button
        type="button"
        className="menu-checklist__chip"
        onClick={onOpen}
        data-testid="menu-checklist-chip"
      >
        <i className="f7-icons" aria-hidden="true">
          exclamationmark_triangle_fill
        </i>
        <span>{parts.join(' · ')}</span>
      </button>
    </div>
  );
}
